import Slider from '../../components/common/Slider/Slider';
import AboutUs from './Components/AboutUs'
import Carousel from '../../components/common/Carousel/Carousel'
import VideoCarousel from '../../components/common/VideoCarousel/VideoCarousel'


import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';


const Home = () => {
    return (
        <div>
            <Slider API_ENDPOINTS_SLIDER={API_ENDPOINTS.SLIDES} PARAMS_SLIDER={POPULATE_PARAMS.HOME_SLIDER} />
            <AboutUs />
            <Carousel title='Duyurular & Haberler' endpoint={API_ENDPOINTS.POSTS} urlendpoint={URL_ENDPOINTS.POSTS} itemsPerPage={6} />
            <Carousel title='Yayınlar' endpoint={API_ENDPOINTS.PUBLICATIONS} urlendpoint={URL_ENDPOINTS.PUBLICATIONS} itemsPerPage={5} bgColor='#fffff' textColor='#1e3a8a' arrowColor='#1e3a8a' cardLayout='hor' />
            <VideoCarousel title='Video' endpoint='videos' itemsPerPage={4} />
        </div>
    );
};

// const styles = {
//     container: {
//         maxWidth: '1200px',
//         margin: '0 auto '
//     }
// };

export default Home;